/**
 * A white number in a circle on an icon (the icon's button is relative).
 * Hidden at 0, "99+" above 99.
 */
export default function CountBadge({
  count,
  color,
}: {
  count: number;
  color: string;
}) {
  if (count <= 0) return null;
  return (
    <span
      aria-hidden="true"
      className={`absolute -right-2 -top-2 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full px-1 text-xs font-bold leading-none text-white ${color}`}
    >
      {count > 99 ? "99+" : count}
    </span>
  );
}
